/**
 * Represents current user information
 */
export interface UserInfo {
	id: string;
	email?: string;
	isAdmin?: boolean;
	isPremium?: boolean;
	firstName?: string;
	lastName?: string;
	telegramId?: string;
	nativeLanguage?: string;
	learnedLanguage?: string;
	[key: string]: any;
}

/**
 * Current user service abstraction.
 * Provides access to currently authenticated user information.
 */
export abstract class ICurrentUser {
	/**
	 * Initialize/refresh user data
	 */
	abstract initialize(): Promise<void>;

	/**
	 * Explicit refresh hook (some hosts call refresh separately from initialize).
	 */
	abstract refresh(): Promise<void>;

	/**
	 * Get current user information
	 * @returns User info if authenticated, null otherwise
	 */
	abstract getUserInfo(): UserInfo | null;

	/**
	 * Get current user ID
	 * @returns User ID if authenticated, null otherwise
	 */
	abstract getUserId(): string | null;

	/**
	 * Check if user is authenticated
	 */
	abstract isAuthenticated(): boolean;

	/**
	 * Check if user is admin
	 */
	abstract isAdmin(): boolean;

	/**
	 * Check if user has premium subscription
	 */
	abstract isPremium(): boolean;

	/**
	 * Premium expiry (if known). ISO string or null when unknown/not premium.
	 */
	abstract getPremiumExpiresAt(): string | null;

	/**
	 * Logout the current user
	 */
	abstract logout(): Promise<void>;
}
